<template>
<div v-if="stepper.steps && stepper.steps.length > 0" class="stepper" :class="{'stepper-scrolled': scrolled}">

    <div class="stepper-button-left">
        <vm-button rounded :text="currentStep().pText" :disabled="currentStep().pDisabled" @clicked="handleStepClick(stepper.step - 2)" />
    </div>
    <div class="stepper-button-right">
        <vm-button rounded :text="currentStep().nText" :disabled="currentStep().nDisabled" @clicked="handleStepClick(stepper.step)" />
    </div>

    <div class="stepper-steps">

        <div v-for="(step, i) in stepper.steps" :key="i" class="stepper-step"
            :class="[
                {'stepper-active': (i+1) == stepper.step},
                {'stepper-disabled': i >= stepper.step},
            ]">

            <div class="stepper-ball" @click="handleStepClick(i)">
                <label>{{ i + 1 }}</label>
            </div>
            <div class="stepper-title">
                <label>{{ step.label }}</label>
            </div>
            <div class="stepper-line" v-if="i > 0" />

        </div>

    </div>

    <div v-if="showMessage" class="stepper-top-message" :class="{'stepper-top-message-error': messageError}">
        <div style="display: flex; width: 800px; margin: 0 auto;">
            <div style="margin-right: 10px;" v-if="!messageError">
                <svg height="24" version="1.1" width="24" xmlns="http://www.w3.org/2000/svg" style="transform: scale(1.4); margin-top: 6px;">
                    <path d="M9 19.4L3.3 13.7 4.7 12.3 9 16.6 20.3 5.3 21.7 6.7z"/>
                </svg>
            </div>
            <div style="margin-right: 10px;" v-if="messageError">
                <svg height="24" version="1.1" width="24" xmlns="http://www.w3.org/2000/svg" style="transform: scale(1.0); margin-top: 9px;">
                    <path d="M23,20L12,1.7L1,20H23z M13,18h-2v-2h2V18z M13,14h-2V9h2V14z"/>
                </svg>
            </div>
            <div style="margin-top: 12px; font-size: 15px;">
                <label>{{ messageText }}</label>
            </div>
        </div>
    </div>

</div>
</template>
<script>
/* eslint-disable no-unused-vars */
export default {
name: 'Stepper',
props: {
    stepper: {
        type: Object,
        default: null
    },
    showMessage: {
        type: Boolean,
        default: false
    },
    messageError: {
        type: Boolean,
        default: false
    },
    messageText: {
        type: String,
        default: ''
    }
},
data() {
    return {
        scrolled: false
    }
},
watch: {
    stepper: {
        deep: true,
        handler(val) {
            //console.log('HS: data changed', val);
        }
    },
},
methods: {
    handleStepClick(index) {
        const currentIndex = this.stepper.step - 1;
        if (index < 0) return;
        if (index > currentIndex) {
            if (this.stepper.step == 1 && this.stepper.steps[this.stepper.step - 1].nDisabled) return;
        }
        if (index >= this.stepper.steps.length) return this.$emit('submit', true);
        this.$emit('step', this.stepper.steps[index].key);
    },
    handleScroll() {
        let doc = document.documentElement;
        let top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
        if (top > 60 && !this.scrolled) this.scrolled = true;
        if (top <= 60 && this.scrolled) this.scrolled = false;
    },
    currentStep() {
        return this.stepper.steps[this.stepper.step - 1];
    }
},
async mounted() {
    window.addEventListener('scroll', this.handleScroll);
},
destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
}
}
</script>
<style scoped>

.stepper {
    position: relative;
    width: 100%;
    height: 70px;
    background-color: #004976;
    margin-bottom: -60px;
    z-index: 2;
}
.stepper-scrolled {
    position: fixed;
    top: 0px;
}

.stepper-steps {
    display: flex;
    width: 600px;
    margin: 0 auto;
    padding-top: 9px;
}

.stepper-step {
    position: relative;
    width: 200px;
    text-align: center;
}

.stepper-ball {
    width: 32px; height: 32px;
    margin: 0 auto;
    color: #004976;
    padding-top: 4px;
    border-radius: 50%;
    border: solid 2px white;
    background-color: white;
    box-sizing: border-box;
    cursor: pointer;
}
.stepper-ball label {
    font-size: 18px;
    cursor: pointer;
}

.stepper-active .stepper-ball {
    color: white;
    border: solid 2px white;
    background-color: transparent;
}

.stepper-disabled .stepper-ball {
    color: #597586;
    border: solid 2px #597586;
    background-color: transparent;
}

.stepper-title {
    margin-top: 5px;
    font-size: 13px;
    color: #9eb2be;
}

.stepper-active .stepper-title {
    color: white;
}

.stepper-disabled .stepper-title {
    color: #597586;
}

.stepper-line {
    position: absolute;
    width: 124px; height: 2px;
    top: 16px; left: -62px;
    background-color: white;
}

.stepper-active .stepper-line {
    background-color: white;
}

.stepper-disabled .stepper-line {
    background-color: #597586;
}

.stepper-button-left {
    position: absolute;
    top: 12px; left: 20px;
}
.stepper-button-right {
    position: absolute;
    top: 12px; right: 20px;
}

@media only screen and (max-width: 1000px) {
    .stepper-button-left {
        display: none;
    }
    .stepper-button-right {
        display: none;
    }
}

.stepper-top-message {
    width: 100%;
    margin-top: 8px;
    min-height: 42px;
    color: #386855;
    background-color: #dbf4d6;
}
.stepper-top-message-error {
    color: white;
    background-color: #E66156;
}
.stepper-top-message path {
    fill: green;
}
.stepper-top-message-error path {
    fill: white;
}

</style>s
